import { ExamEventDetails, ExamEventDetailsPermissionRoute } from '@exam-center/exam-event-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { WithPermission } from '@shared/permissions';

export default function ExamEventDetailsPage() {
  const { examCenterCode, examEventId } = useParams('/:examCenterCode/exam-events/:examEventId');

  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW}
      errorElement={ExamEventDetailsPermissionRoute}
      slotProps={{ errorElement: { examCenterCode, examEventId } }}
    >
      <ExamEventDetails />
    </WithPermission>
  );
}
